// extracted by mini-css-extract-plugin
var _1 = "button--OwVCH";
var _2 = "content--jEzxT";
var _3 = "danger--bY4YW";
var _4 = "disabled--iGSLe";
var _5 = "fullWidth--XknAn";
var _6 = "large--Tu4NU";
var _7 = "loading--F55fs";
var _8 = "medium--gSsNu";
var _9 = "outline--wZhOl";
var _a = "primary--rUEw6";
var _b = "rotate--E5zcX";
var _c = "secondary--GDN5d";
var _d = "small--kk3Wh";
var _e = "spinner--IQ4XD";
var _f = "success--ZsrNZ";
export { _1 as "button", _2 as "content", _3 as "danger", _4 as "disabled", _5 as "fullWidth", _6 as "large", _7 as "loading", _8 as "medium", _9 as "outline", _a as "primary", _b as "rotate", _c as "secondary", _d as "small", _e as "spinner", _f as "success" }
